import * as Logger from '../../common/tools/logger';
import { CONFIG_LAYER_DEFAULT_CLASSNAME } from '../../config';

/**
 * Class to provide some services for the layer
 */
export class LayerService {

  public permissionLayer: HTMLElement;
  private moduleName = 'LayerService';

  constructor(containerOrSelector?: string | HTMLElement) {
    if (containerOrSelector instanceof HTMLElement) {
      this.permissionLayer = containerOrSelector;
    } else if (typeof containerOrSelector === 'string') {
      try {
        this.permissionLayer = document.querySelector(containerOrSelector);
      } catch (ex) {
        Logger.error(this.moduleName, 'initialize', ex);
      }
    } else {
      Logger.info(this.moduleName, 'initialize', 'No layer element found, creating a new one.');
      this.permissionLayer = this.createLayer();
      document.body.appendChild(this.permissionLayer);
    }
  }

  /**
   * @protected
   * @function createLayer
   * @description Function to create a new layer
   * @return {HTMLDivElement}
   */
  protected createLayer(): HTMLDivElement {
    const container = document.createElement('div');
    container.classList.add(CONFIG_LAYER_DEFAULT_CLASSNAME);
    return container;
  }

  /**
   * @public
   * @function removeLayer
   * @description Function to remove a layer
   * @return {void}
   */
  public removeLayer(): void {

    if (!this.permissionLayer) {
      Logger.warn(this.moduleName, 'removeLayer', 'There is no layer to be removed.');
      return;
    }

    try {
      if (this.permissionLayer && this.permissionLayer.parentNode) {
        this.permissionLayer.parentNode.removeChild(this.permissionLayer);
      }
      this.permissionLayer = null;
    } catch (ex) {
      Logger.error(this.moduleName, 'removeLayer', ex);
    }

  }

}
